// Paletas de colores personalizadas
export const orangePalette = {
  50: '#fdf3ed',
  100: '#fbe7db',
  200: '#f8cfb7',
  300: '#f5b793',
  400: '#f29f6f',
  500: '#cb6e28', // Color base
  600: '#a25820',
  700: '#794218',
  800: '#502c10',
  900: '#271608'
};

export const greenPalette = {
  50: '#e6f2ec',
  100: '#cce5d9',
  200: '#99cbb3',
  300: '#66b18d',
  400: '#339767',
  500: '#006937', // Color base
  600: '#00542c',
  700: '#003f21',
  800: '#002a16',
  900: '#00150b'
};

export const blackPalette = {
  50: '#e9e9e9',
  100: '#d3d3d3',
  200: '#a8a7a7',
  300: '#7c7b7b',
  400: '#514f50',
  500: '#231f20', // Color base
  600: '#1c191a',
  700: '#151314',
  800: '#0e0c0d',
  900: '#070607'
};

// Neutros cálidos para fondos y superficies
export const sandPalette = {
  50: '#fdfbf8',
  100: '#faf6f0', // Fondo general
  200: '#f3ebdf',
  300: '#e8dcc8',
  400: '#d6c3a5',
  500: '#bfa57e'
};
